import { infiniteQueryOptions, queryOptions } from "@tanstack/react-query";
import { getGolfHoleList, getGolfparkDetail, getMainData, getMainDetail, mainGolfParkSearch, } from "../v1/main.service";
import type { MainRequest, GolfParkSearchRequest, MainGolfParkDetailRequest } from "../dto/request/main.request";

export const useGetMain = (form?: MainRequest) => queryOptions({
    queryKey: ["parkgolf-main", form?.latitude, form?.longitude, 6],
    queryFn: () => getMainData(form),
    retry: 1
})

export const useGetMainDetail = (code: string, form?: MainGolfParkDetailRequest) => queryOptions({
  queryKey: ["parkgolf-main-detail", code, form],
  queryFn: () => getMainDetail(code, form),
  retry: 1
})

/** 골프장 검색 */
export const useMainGolfParkSearch = (form?: GolfParkSearchRequest) => infiniteQueryOptions({
  queryKey: ["parkgolf-main-golfpark-search", form],
  queryFn: ({ pageParam }) => mainGolfParkSearch({...form, page: pageParam, pageSize: 10}),
  retry: 1,
  initialPageParam: 1,
  getNextPageParam: (lastPage, pages) => {
    const fetchedItemsCount = lastPage.data.golfParkList.length || 0;
    if (fetchedItemsCount < 10) {
      return undefined;
    }

    return pages.length + 1;
  },
  refetchOnMount: false,
  refetchOnWindowFocus: false,
  refetchOnReconnect: false,
});

export const useMainGolfParkDetail = (code: string) => queryOptions({
  queryKey: ["parkgolf-main-golfpark-detail", code],
  queryFn: () => getGolfparkDetail(code),
  retry: 1
})

/** 홀 정보 */
export const useGolfHoleList = (courseCode: string) =>
  queryOptions({
    queryKey: ["parkgolf-golfhole", courseCode],
    queryFn: () => getGolfHoleList(courseCode),
    enabled: !!courseCode, // 코드가 있을 때만 실행
    retry: 1,
  });